import { FaApple, FaWindows } from "react-icons/fa";
import { MdOutlineDesktopWindows } from "react-icons/md";
import { IoChatbubbleOutline } from "react-icons/io5";
import exchangeMfa from "../assets/images/iam/Exchange MFA.svg"
import idp from "../assets/images/iam/IDP.svg"
import internalApps from "../assets/images/iam/internal apps.svg"
import iwamfa from "../assets/images/iam/IWA MFA.svg"
import mfa from "../assets/images/iam/mfa.svg"
import sharepoint from "../assets/images/iam/sharepoint.svg"
import sp from "../assets/images/iam/SP.svg"
import sso from "../assets/images/iam/SSO.svg"
import windowsMfa from "../assets/images/iam/windows mfa.svg"
import workflow from "../assets/images/iam/workflow.svg"
import usergroup from "../assets/images/iam/user-group.svg"

const cards = [
    {
        text: "Web & Mobile SSO",
        icon: <span class="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>devices</span>,
        videoId:"yNPtNVyU-s4",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['web', 'mobile', 'sso', 'knobita'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Passwordless Login",
        icon: <span class="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>sms</span>,
        videoId:"t81c0H2Wsyo",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['passwordless', 'login'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Social Login",
        icon: <IoChatbubbleOutline className="material-symbols-rounded" style={{fontSize:'32px', color:"rgb(91,91,91)"}}/>,
        videoId:"rr6o2wY7HC0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['login'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Self Service Registration",
        icon: <span class="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}} >verified_user</span>,
        videoId:"yH53KpaKyI4",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['service', 'registration'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Progressive Profiling",
        icon: <span class="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>flowchart</span>,
        videoId:"25eIEJDzZvU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['progress'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Workflows and Approvals",
        icon: <span class="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>checklist</span>,
        videoId:"0-VGoZN5Gg8",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['workflow', 'approval'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "User Sync",
        icon: <span class=" material-symbols-rounded" style={{fontSize:"34px", color:"rgb(91,91,91)"}}>sync</span>,
        videoId:"re8XMNCb9Qg",
        videoType:"youtube",
        isMultiple: false,
        cardType: "customer",
        tags: ['sync'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Single Sign-On and Multi-Factor Authentication",
        icon: <span className="material-symbols-rounded" style={{fontSize:"34px", color:"rgb(91,91,91)"}}>account_tree</span>,
        videoId:"uSoTL-QtNOg",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['sso','mfa'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "IDP (Identity Provider) Initiated SSO",
        icon: <img src={idp} alt="IDP" />,
        videoId:"ygHI5tqCAbQ",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['IDP', 'SSO'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "SP (Service Provider) Initiated SSO",
        icon: <img src={sso} alt="SSO" />,
        videoId:"SPVmanMqEOE",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['IDP', 'SSO','Application'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Internal / Custom Applications SSO",
        icon: <img src={internalApps} alt="Internal Apps" />,
        videoId:"YFX3r4hjtYc",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['Internal', 'Custom', 'applications', 'SSO'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "SSO for Legacy Apps (Oracle EBS)",
        icon: <span className="material-symbols-outlined" style={{fontSize:'33px', color:"rgb(91,91,91)"}}>apps</span>,
        videoId:"ixtIEDZHVTM",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['apps'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "SSO via Password Manager (Browser Extension)",
        icon: <span className="material-symbols-outlined" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>open_in_browser</span>,
        videoId:"J1H3Kt3YP4w",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['SSO', 'Browser Extension'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "SSO for Shared Accounts via Password Manager",
        icon: <span className="material-symbols-outlined" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>ads_click</span>,
        videoId:"k7M2XEZrV8",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['SSO', 'Browser Extension', 'Shared Apps'],
        desc:"",
        subCategory: "SSO"
    },
    {
        text: "Passwordless Authentication for Endpoints",
        icon: <span className="material-symbols-outlined" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>password_2_off</span>,
        videoId:"aJUJw534vCE",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['passwordless', 'auth', 'endpoint'],
        desc:"",
        subCategory: "SSO"
    },



    {
        text: "Multi-Factor Authentication",
        icon: <img src={mfa} alt="MFA" />,
        videoId:"CqmfDWI8x7k",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['mfa'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "VPN MFA",
        icon: <span class="material-symbols-rounded"  style={{fontSize:'34px', color:"rgb(91,91,91)"}}>router</span>,
        videoId:"8O5WvljFYy0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['mfa'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "Windows MFA",
        icon: <img src={windowsMfa} alt="WindowsMFA" />,
        cardType: "employee",
        isMultiple: false,
        videoId: "0ZmBySBHn5o",
        videoType: "youtube",
        tags: ['access', 'mfa'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "Linux MFA",
        icon: <MdOutlineDesktopWindows style={{fontSize:'34px', color:"rgb(91,91,91)"}} className="material-symbols-rounded" />,
        isMultiple: false,
        videoType: "youtube",
        cardType: "employee",
        videoId: "KAztAhKLHDw",
        tags: ['access', 'mfa'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "MacOS MFA",
        icon: <FaApple className="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}}/>,
        isMultiple: false,
        videoType: "youtube",
        cardType: "employee",
        videoId: "uzSVUvQzhJg",
        tags: ['access', 'mfa'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "Windows MFA and Integrated Windows Authentication",
        icon: <img src={iwamfa} alt="IWA MFA" />,
        videoId:"ut-jSjgAzXU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['MFA', 'IWA', 'Windows'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "Sharepoint Multi-Factor Authentication (MFA)",
        icon: <img src={sharepoint} alt="Sharepoint" />,
        videoId:"eL_dDDUJTAU",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['Sharepoint', 'MFA'],
        desc:"",
        subCategory: "MFA"
    },
    {
        text: "Exchange Multi-Factor Authentication (MFA)",
        icon: <img src={exchangeMfa} alt="Exchange MFA" />,
        videoId:"-9dtg3dakz0",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['Exchange', 'Microsoft', 'MFA'],
        desc:"",
        subCategory: "MFA"
    },

    {
        text: "Adaptive Authentication",
        icon: <span className="material-symbols-outlined" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>public</span>,
        videoId:"cOXqBhRshLc",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['Adaptive', 'Authentication', 'Restrictions'],
        desc:"",
        subCategory: "Adaptive"
    },
    {
        text: "Personal Email Block",
        icon: <span className="material-symbols-outlined" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>unsubscribe</span>,
        videoId:"HK5qEiKBFg8",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['Personal', 'Email Block', 'SSO'],
        desc:"",
        subCategory: "Adaptive"
    },
    {
        text: "Adaptive Access",
        icon: <span class="material-symbols-rounded" style={{fontSize:'34px', color:"rgb(91,91,91)"}}>lock_clock</span>,
        videoId:"QeZEZWZR5i4",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['adaptive', 'access'],
        desc:"",
        subCategory: "Adaptive"
    },
     
    {
        text: "User-Role Based Provisioning",
        icon: <img src={usergroup} height='40px' alt="User-Role Based Provisioning" />,
        videoId:"EWi2pxDm3LA",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['Provisioning'],
        desc:"",
        subCategory: "ULM"
    },
    {
        text: "Workflows and App Approval",
        icon: <img src={workflow} alt="workflow" />,
        videoId:"ztqOg99SKRM",
        videoType:"youtube",
        isMultiple: false,
        cardType: "employee",
        tags: ['workflow', 'app', 'approval'],
        desc:"",
        subCategory: "ULM"
    },
	
]

const liveDemoCards = [
    {
        title: "VPN MFA",
        image: "/iam/vpn-mfa-live-demo.png",
        link: "https://www.miniorange.com/iam/demo/vpn-mfa"
    },
    {
        title: "Adaptive MFA",
        image: "/iam/adaptive-mfa-live-demo.png",
        link: "https://www.miniorange.com/iam/demo/adaptive-authentication"
    },
    {
        title: "Single Sign-On",
        image: "/iam/sso-live-demo.png",
        link: "https://www.miniorange.com/iam/demo/single-sign-on-sso"
    },
    {
        title: "JD Edwards SSO",
        image: "/iam/oracle-jd-edwards-sso-live-demo.png",
        link: "https://www.miniorange.com/iam/demo/oracle-jd-edwards-sso"
    }
];


export { cards, liveDemoCards };